export const IssueMethod = {
  MANUAL: 'MANUAL',
  BACKFLUSH: 'BACKFLUSH',
};

export const IssueMethodList = [
  { label: 'Kézi', value: IssueMethod.MANUAL },
  //{ label: 'Háttérkönyvelés', value: IssueMethod.BACKFLUSH },
];
